import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import Pagination from './Pagination';
import './carousel.scss';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const tutorialSteps = [
  {
    label: 'Descubre los beneficios de ser parte de Contacta Abogado®',
    imgPath: '/img/silderRegistro/imagen-abogado.png',
    pocition: 'flex-end',
    text:
      ' Crea una cuenta y comienza a conectar con clientes potenciales que esperan por tu ayuda.',
  },
  {
    label: 'Anunciate sin Límites',
    imgPath: '/img/silderRegistro/imagen-abogado2.png',
    pocition: 'flex-end',
    text:
      ' Convierte tu cuenta a premium y aparece en los principales lugares en la lista de búsqueda.',
  },
  {
    label: 'Deja que clientes potenciales te encuentren',
    imgPath: '/img/silderRegistro/imagen-abogada.png',
    pocition: 'flex-start',
    text:
      ' ¡Ingresa tus datos de contacto y perfil profesional para que más personas te contacten!',
  },
  {
    label: '¿Tienes un despacho?',
    imgPath: null,
    pocition: null,
    text: ' ¡Regístrate y agrega a tus colaboradores!',
  },
];

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    flexGrow: 1,
    position: 'relative',
    height: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: '92vh',
    //maxHeight: 768,
    //maxWidth: 700,
    //maxHeight: 1080,
    /* [theme.breakpoints.down(1360)]: {
      maxHeight: 768
    }, */
    paddingTop: '4%',
    display: 'block',
    overflow: 'hidden',
    '@media (max-height: 635px)': {
      height: 600,
    },
  },

  steps: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    background: 'none',
    width: '50%',
  },
  imgPocition: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  imgPocition2: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  backImage: {
    background:
      'url(/img/silderRegistro/Background/bg-imagen.jpg) no-repeat center ',
    backgroundPosition: 'bottom right',
    WebkitBackgroundSize: 'cover',
    MozBackgroundSize: 'cover',
    OBackgroundSize: 'cover',
    backgroundSize: 'cover',
  },
}));

function SwipeableTextMobileStepper() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = tutorialSteps.length;

  // const handleNext = () => {
  //   setActiveStep(prevActiveStep => prevActiveStep + 1);
  // };

  // const handleBack = () => {
  //   setActiveStep(prevActiveStep => prevActiveStep - 1);
  // };

  const handleStepChange = step => {
    setActiveStep(step);
  };

  return (
    <div className={`${classes.root} ${classes.backImage}`}>
      <div className={`primary-text text-${activeStep}`}>
        <p
          dangerouslySetInnerHTML={{ __html: tutorialSteps[activeStep].label }}
        />
        {/* <p className={`secondary-text align-text-${activeStep}`}></p> */}
        <p className={`secondary-text text-${activeStep}`}>
          {tutorialSteps[activeStep].text}
        </p>
      </div>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        interval={50000}
        enableMouseEvents
      >
        {tutorialSteps.map((step, index) => (
          <div
            key={step.label}
            style={{ display: 'flex', alignItems: 'flex-end' }}
          >
            {Math.abs(activeStep - index) <= 2 ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: step.pocition,
                  width: '100%',
                }}
              >
                {step.imgPath ? (
                  <img
                    className={classes.img}
                    src={step.imgPath}
                    alt={step.label}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <Pagination
        dots={maxSteps}
        index={activeStep}
        onChangeIndex={handleStepChange}
      />
    </div>
  );
}

export default SwipeableTextMobileStepper;
